import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Reveal } from '../components/Reveal';
import { brands } from '../mockData';

const PortfolioPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white pt-24 md:pt-32">
      <section className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto mb-16 md:mb-24">
        <Reveal>
          <button
            data-testid="portfolio-back-button"
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.2em] text-[#9CA3AF] hover:text-[#B8960C] transition-colors duration-300 mb-12"
          >
            <ArrowLeft size={14} strokeWidth={1.5} />
            Back to Home
          </button>
          <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-[#B8960C] mb-6">Portfolio</p>
          <h1
            data-testid="portfolio-page-heading"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light text-[#1A1A1A] uppercase leading-tight"
            style={{ letterSpacing: '0.1em' }}
          >
            Our Brands
          </h1>
          <div className="w-16 h-px bg-[#B8960C] mt-8 opacity-40"></div>
        </Reveal>
      </section>

      <section
        data-testid="portfolio-brands-section"
        className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto pb-24 md:pb-32 lg:pb-48"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {brands.map((brand) => {
            const url = brand.socials?.website || '#';
            return (
              <Reveal key={brand.id} delay={0.08}>
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`brand-card-${brand.slug}`}
                  className="block border border-black/5 hover:border-[#B8960C]/30 transition-all duration-500 group overflow-hidden bg-white"
                >
                  <div className="flex items-center justify-center p-8 md:p-12 min-h-[240px] md:min-h-[300px]">
                    <img
                      src={brand.image}
                      alt={brand.name}
                      className="max-w-full max-h-[200px] md:max-h-[240px] object-contain transition-transform duration-700 group-hover:scale-105 opacity-90 group-hover:opacity-100"
                    />
                  </div>
                </a>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default PortfolioPage;
